import classNames from 'classnames'
import React, { ReactNode } from 'react'

import CircleLoader from './CircleLoader/CircleLoader'
import styles from './IconMenuButton.module.scss'
import Link from './Link/Link'

export type IconMenuButtonLightProps = {
  type?: 'icon' | 'iconText' | 'text'
  dataTooltipId?: string
  className?: string
  blank?: boolean
  enabled?: boolean
  responsive?: boolean
  isHoverWhite?: boolean
  isHoverBg?: boolean
  loading?: boolean
  loadingIcon?: boolean
  loaderClassname?: string
  selected?: boolean
  text?: string | JSX.Element
  subContent?: JSX.Element
  onClick?: (e?: any) => void
  href?: string
  blur?: boolean
  id?: string
  onMouseDown?: (e?: any) => void
  onMouseEnter?: (e?: any) => void
  onMouseLeave?: (e?: any) => void
}

const IconMenuButtonLight: React.FC<IconMenuButtonLightProps & { icon?: ReactNode }> = (props) => {
  const className = classNames(
    styles.container,
    props.className,
    { [styles.isHoverWhite]: props.isHoverWhite },
    { [styles.isHoverBg]: props.isHoverBg },
    { [styles.enabled]: props.enabled },
    { [styles.blur]: props.blur },
    { [styles.responsive]: props.responsive },
    { [styles.textOnly]: props.icon === 'none' },
  )

  if (props.href && props.enabled) {
    return (
      <Link
        id={props.id}
        href={props.href}
        target={props.blank ? '_blank' : undefined}
        rel={props.blank ? 'noreferrer' : undefined}
        className={className}
        data-disabled={!props.enabled}
        data-selected={props.selected}
        data-loading={props.loading}
      >
        {props.icon}
        {props.text !== '' && (props.type === 'iconText' ? props.text : <span>{props.text}</span>)}
      </Link>
    )
  }
  return (
    <div
      id={props.id}
      onClick={props.enabled ? props.onClick : () => void 0}
      onMouseDown={props.enabled ? props.onMouseDown : () => void 0}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      className={className}
      data-disabled={!props.enabled}
      data-selected={props.selected}
      data-loading={props.loading}
      data-tooltip-id={props.dataTooltipId}
    >
      {props.loadingIcon ? (
        <div className={classNames(styles.loader, props.loaderClassname)}>
          <CircleLoader />
        </div>
      ) : (
        props.icon
      )}
      {props.text !== '' && (props.type === 'iconText' ? props.text : <span>{props.text}</span>)}
      {props.subContent || null}
    </div>
  )
}

IconMenuButtonLight.defaultProps = {
  className: '',
  enabled: true,
  responsive: true,
  isHoverWhite: false,
  isHoverBg: false,
  icon: 'none',
  text: '',
  selected: false,
  onClick: () => void 0,
}

export default IconMenuButtonLight
